import { api } from "@/lib/api";

export interface PushSubscriptionData {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
  deviceInfo?: {
    userAgent?: string;
    platform?: string;
    deviceName?: string;
  };
}

export const pushNotificationApi = {
  // Subscribe to push notifications
  subscribe: async (subscription: PushSubscriptionData) => {
    const response = await api.post("push-subscriptions", subscription);
    return response.data;
  },

  // Get all subscriptions
  getSubscriptions: async () => {
    const response = await api.get("push-subscriptions");
    return response.data;
  },

  // Unsubscribe
  unsubscribe: async (endpoint: string) => {
    const response = await api.delete(
      `push-subscriptions?endpoint=${encodeURIComponent(endpoint)}`
    );
    return response.data;
  },

  // Toggle subscription
  toggleSubscription: async (endpoint: string, enabled: boolean) => {
    const response = await api.patch("push-subscriptions", {
      endpoint,
      enabled,
    });
    return response.data;
  },
};
